(function () {
  const cartCheckoutButton = document.querySelector('button[name="checkout"]');
  const attributeInputs = document.querySelectorAll('[name^="attributes"]');

  function updateCartAttributes(which) {
    // console.log("Function name:", which)
    const attributes = {};

    // Use a Set to avoid duplicate attribute groups (e.g., radio groups)
    const handledNames = new Set();

    attributeInputs.forEach(input => {
      const rawName = input.name; // e.g., attributes[shipping_option]
      const attrName = rawName.replace(/^attributes\[/, '').replace(/\]$/, '');

      if (handledNames.has(attrName)) return;

      if (input.type === 'radio') {
        if (input?.checked) {
          attributes[attrName] = input.value;
          handledNames.add(attrName);
        }
      } else if (input.type === 'checkbox') {
        if (input?.checked) {
          attributes[attrName] = input.value;
          handledNames.add(attrName);
        }
      } else {
        attributes[attrName] = input.value;
        handledNames.add(attrName);
      }
    });

    // console.log('attributes', attributes);

    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ attributes }),
    })
      .then(response => {
        // console.log('Cart updated successfully:', response);
        return response.json(); // optional, if you want to see the response body
      })
      .then(data => {
        // console.log('Response data:', data); // optional
        if (window.wcp_data && window.wcp_data.wcp_cart) {
          // Clean the object of null values before assigning it.
          window.wcp_data.wcp_cart.attributes = Object.fromEntries(
            Object.entries(attributes).filter(
              ([, value]) => value !== null && value !== '' && value !== undefined
            )
          );
          // console.log(' Synced wcp_cart.attributes:', window.wcp_data.wcp_cart.attributes);
        } else {
          console.warn('⚠wcp_data.wcp_cart not available');
        }
      })
      .catch(err => {
        console.error(' Error updating cart attributes:', err);
      });

  }

  // Attach listener to checkout button
  if (cartCheckoutButton && !window.jcCheckoutBtnHandled) {
    cartCheckoutButton.addEventListener('click', () => updateCartAttributes("button"), false);
    window.jcCheckoutBtnHandled = true;
  }

  // Attach listeners to all attribute inputs
  if (cartCheckoutButton && !window.jcAttrFieldsHandled) {
    attributeInputs.forEach(input => {
      input.addEventListener('change', (e) => {
        // console.log('change target', e.target);
        updateCartAttributes("Attribute");
      }, false);
    });
    window.jcAttrFieldsHandled = true;
  }

})();
